import { ConversionFormatSwitcherComponent } from '../tools/convert/components/conversion-format-switcher/conversion-format-switcher.component';
import { ConvertFromFormatListComponent } from '../tools/convert/components/convert-from-format-list/convert-from-format-list.component';
import { ConvertComponent } from '../tools/convert/components/convert/convert.component';
import { BadgeListComponent } from './components/badge-list/badge-list.component';
import { BlogPostLinkListComponent } from './components/blog-post-link-list/blog-post-link-list.component';
import { CheckListComponent } from './components/check-list/check-list.component';
import { ClaimComponent } from './components/claim/claim.component';
import { CompanyLogoListComponent } from './components/company-logo-list/company-logo-list.component';
import { ComparisonComponent } from './components/comparison/comparison.component';
import { ContentGroupComponent } from './components/content-group/content-group.component';
import { FaqListComponent } from './components/faq-list/faq-list.component';
import { FeatureItemListComponent } from './components/feature-item-list/feature-item-list.component';
import { FormComponent } from './components/form/form.component';
import { GalleryShowcaseListComponent } from './components/gallery-showcase-list/gallery-showcase-list.component';
import { HomeTeaserComponent } from './components/home-teaser/home-teaser.component';
import { IconWithTextListComponent } from './components/icon-with-text-list/icon-with-text-list.component';
import { ImageComponent } from './components/image/image.component';
import { LargeLinkListComponent } from './components/large-link-list/large-link-list.component';
import { PinnedBlogPostLinkComponent } from './components/pinned-blog-post-link/pinned-blog-post-link.component';
import { PointListComponent } from './components/point-list/point-list.component';
import { PricingBoxListComponent } from './components/pricing-box-list/pricing-box-list.component';
import { ProductComparisonListItemPreviewComponent } from './components/product-comparison-list-item-preview/product-comparison-list-item-preview.component';
import { ProductComparisonListComponent } from './components/product-comparison-list/product-comparison-list.component';
import { ProductFeatureListComponent } from './components/product-feature-list/product-feature-list.component';
import { StoryblokBlurComponent } from './components/storyblok-blur/storyblok-blur.component';
import { StoryblokButtonComponent } from './components/storyblok-button/storyblok-button.component';
import { SubMenuComponent } from './components/sub-menu/sub-menu.component';
import { TeaserComponent } from './components/teaser/teaser.component';
import { TextComponent } from './components/text/text.component';
import { TitleComponent } from './components/title/title.component';
import { VideoComponent } from './components/video/video.component';

const Components = {
  Teaser: TeaserComponent,
  HomeTeaser: HomeTeaserComponent,
  CompanyLogoList: CompanyLogoListComponent,
  FeatureItemList: FeatureItemListComponent,
  Text: TextComponent,
  Image: ImageComponent,
  Video: VideoComponent,
  CheckList: CheckListComponent,
  ProductFeatureList: ProductFeatureListComponent,
  GalleryShowcaseList: GalleryShowcaseListComponent,
  PricingBoxList: PricingBoxListComponent,
  ProductComparisonList: ProductComparisonListComponent,
  ProductComparison: ProductComparisonListItemPreviewComponent,
  FaqList: FaqListComponent,
  Button: StoryblokButtonComponent,
  Blur: StoryblokBlurComponent,
  BadgeList: BadgeListComponent,
  PointList: PointListComponent,
  IconWithTextList: IconWithTextListComponent,
  LargeLinkList: LargeLinkListComponent,
  Comparison: ComparisonComponent,
  PinnedBlogPostLink: PinnedBlogPostLinkComponent,
  BlogPostLinkList: BlogPostLinkListComponent,
  Claim: ClaimComponent,
  Title: TitleComponent,
  ContentGroup: ContentGroupComponent,
  SubMenu: SubMenuComponent,
  Form: FormComponent,
  Conversion: ConvertComponent,
  ConvertFromFormatList: ConvertFromFormatListComponent,
  ConversionFormatSwitcher: ConversionFormatSwitcherComponent,
} as const;

type ValueOf<T> = T[keyof T];

export type ComponentValues = ValueOf<typeof Components>;

export { Components };
